module.exports = __webpack_public_path__ + "img/empty.7a07a951.png";